import PropTypes from "prop-types";

// Components
import { Link } from "@octopus-investments/deep-sea-components";

// Tracking
import { ampli } from "ampli";

// Styles
import "./FooterText.scss";

export default function FooterText({ isEnabled = true }) {
  function linkClicked(_e, isPrivacy) {
    if (isPrivacy) ampli.privacyPolicyClicked();
    else ampli.termsAndConditionsClicked();
    return true;
  }

  return (
    isEnabled && (
      <div className="footer-txt">
        <div className="container">
          By signing up, you accept our{" "}
          <Link
            href="https://octopusinvestments.com/terms-conditions/"
            onPointerDown={e => linkClicked(e, false)}
            target="_blank"
            title="View Octopus Terms & Conditions"
          >
            Terms &amp; Conditions
          </Link>{" "}
          and{" "}
          <Link
            href="https://octopusinvestments.com/privacy-notice/"
            onPointerDown={e => linkClicked(e, true)}
            target="_blank"
            title="View Octopus Privacy Policy"
          >
            Privacy Policy
          </Link>
          .
        </div>
      </div>
    )
  );
}

FooterText.propTypes = {
  isEnabled: PropTypes.bool,
};
